/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    Paper,
    CardContent,
    Typography,
    Box,
    Fade,
    FormControlLabel,
    Checkbox,
    Button
} from '@mui/material';
import {
    AttachMoney,
    Add,
    Business,
    Code,
    Edit as EditIcon,
    Save as SaveIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';
import { useBudgetLine } from 'hooks/api/terminology/budget-line/useBudgetLine';
import { AnimatedButton, StyledCard, StyledTextField, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';

const AddEditBudgetLine = ({ editingBudgetLine, onBudgetLineSubmitted, projectCodes, branchCodes }) => {
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        description: '',
        fiscalYear: new Date().getFullYear().toString(),
        initialBudget: 0,
        currentBalance: 0,
        isActive: true,
        effectiveFrom: new Date().toISOString().split('T')[0],
        effectiveTo: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        projectCode: {
            id: ''
        }
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [filteredProjectCodes, setFilteredProjectCodes] = useState([]);
    const [selectedBranchCode, setSelectedBranchCode] = useState('');

    const { createBudgetLine, updateBudgetLine } = useBudgetLine();

    // Initialize form data when editing
    useEffect(() => {
        if (editingBudgetLine) {
            console.log('Editing Budget Line:', editingBudgetLine);
            console.log('Available Project Codes:', projectCodes);
            console.log('Available Branch Codes:', branchCodes);
            
            setFormData({
                name: editingBudgetLine.name || '',
                code: editingBudgetLine.code || '',
                description: editingBudgetLine.description || '',
                fiscalYear: editingBudgetLine.fiscalYear || new Date().getFullYear().toString(),
                initialBudget: editingBudgetLine.initialBudget || 0,
                currentBalance: editingBudgetLine.currentBalance || 0,
                isActive: editingBudgetLine.isActive !== undefined ? editingBudgetLine.isActive : true,
                effectiveFrom: editingBudgetLine.effectiveFrom 
                    ? new Date(editingBudgetLine.effectiveFrom).toISOString().split('T')[0]
                    : new Date().toISOString().split('T')[0],
                effectiveTo: editingBudgetLine.effectiveTo 
                    ? new Date(editingBudgetLine.effectiveTo).toISOString().split('T')[0]
                    : new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                projectCode: {
                    id: editingBudgetLine.projectCode?.id || ''
                }
            });

            // Set selected branch code for filtering
            const branchCodeId = editingBudgetLine.projectCode?.branchCode?.id || 
                                 editingBudgetLine.projectCode?.branchCode?.branchCodeId;
            
            console.log('Branch Code ID to set:', branchCodeId);
            
            if (branchCodeId) {
                setSelectedBranchCode(String(branchCodeId));
                filterProjectCodesByBranch(branchCodeId);
            }
        } else {
            // Reset form for new budget line
            setFormData({
                name: '',
                code: '',
                description: '',
                fiscalYear: new Date().getFullYear().toString(),
                initialBudget: 0,
                currentBalance: 0,
                isActive: true,
                effectiveFrom: new Date().toISOString().split('T')[0],
                effectiveTo: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                projectCode: {
                    id: ''
                }
            });
            setSelectedBranchCode('');
            setFilteredProjectCodes([]);
        }
        setErrors({});
    }, [editingBudgetLine, projectCodes]);

    const filterProjectCodesByBranch = (branchCodeId) => {
        const filtered = projectCodes.filter(pc => {
            const pcBranchCodeId = pc.branchCode?.id || pc.branchCode?.branchCodeId;
            return pcBranchCodeId === branchCodeId || 
                   pcBranchCodeId === parseInt(branchCodeId) || 
                   pcBranchCodeId === String(branchCodeId);
        });
        setFilteredProjectCodes(filtered);
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Budget line name is required';
        }
        
        if (!formData.code.trim()) {
            newErrors.code = 'Budget line code is required';
        }

        if (!formData.description.trim()) {
            newErrors.description = 'Description is required';
        }

        if (!selectedBranchCode) {
            newErrors.branchCode = 'Branch code is required';
        }

        if (!formData.projectCode.id) {
            newErrors.projectCode = 'Project code is required';
        }

        if (!formData.fiscalYear.trim()) {
            newErrors.fiscalYear = 'Fiscal year is required';
        }

        // Validate dates
        if (formData.effectiveFrom && formData.effectiveTo) {
            const fromDate = new Date(formData.effectiveFrom);
            const toDate = new Date(formData.effectiveTo);
            
            if (fromDate >= toDate) {
                newErrors.effectiveTo = 'Effective To date must be later than Effective From date';
            }
        }

        // Validate budget values
        if (formData.initialBudget < 0) {
            newErrors.initialBudget = 'Initial budget cannot be negative';
        }

        if (formData.currentBalance < 0) {
            newErrors.currentBalance = 'Current balance cannot be negative';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData((prev) => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }

        // Clear error when user starts typing
        if (errors[name] || errors[name?.split('.')[1]]) {
            setErrors(prev => ({
                ...prev,
                [name]: '',
                [name?.split('.')[1]]: ''
            }));
        }
    };

    const handleBranchCodeChange = (event) => {
        const branchCodeId = event.target.value;
        setSelectedBranchCode(branchCodeId);
        
        // Filter project codes by selected branch
        filterProjectCodesByBranch(branchCodeId);
        
        // Reset project code selection
        setFormData(prev => ({
            ...prev,
            projectCode: { id: '' }
        }));

        // Clear errors
        if (errors.branchCode) {
            setErrors(prev => ({ ...prev, branchCode: '' }));
        }
        if (errors.projectCode) {
            setErrors(prev => ({ ...prev, projectCode: '' }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all required fields correctly.'
            });
            return;
        }

        setLoading(true);
        try {
            // Prepare data for submission
            const submitData = {
                ...formData,
                initialBudget: Number(formData.initialBudget),
                currentBalance: Number(formData.currentBalance),
                effectiveFrom: new Date(formData.effectiveFrom).toISOString(),
                effectiveTo: new Date(formData.effectiveTo).toISOString()
            };

            if (editingBudgetLine) {
                await updateBudgetLine(editingBudgetLine.id, submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Budget Line Updated',
                    text: 'The budget line has been successfully updated.',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                await createBudgetLine(submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Budget Line Created',
                    text: 'The budget line has been successfully created.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            onBudgetLineSubmitted();
        } catch (error) {
            logger.error('Error saving budget line:', error);
            
            let errorMessage = `Failed to ${editingBudgetLine ? 'update' : 'create'} the budget line. Please try again.`;
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        onBudgetLineSubmitted();
    };

    // Generate fiscal year options (current year ± 5 years)
    const generateFiscalYears = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear - 5; i <= currentYear + 5; i++) {
            years.push(i.toString());
        }
        return years;
    };

    return (
        <Fade in timeout={1000}>
            <StyledCard elevation={0}>
                <CardContent>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: globalColor,
                            fontWeight: 'bold',
                            mb: 4
                        }}
                    >
                        <AttachMoney /> {editingBudgetLine ? 'Edit Budget Line' : 'Add New Budget Line'}
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="branchCode"
                                label="Branch Code *"
                                value={selectedBranchCode}
                                onChange={handleBranchCodeChange}
                                variant="outlined"
                                error={!!errors.branchCode}
                                helperText={errors.branchCode}
                                disabled={loading}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ mr: 1, color: globalColor }}>
                                            <Business fontSize="small" />
                                        </Box>
                                    )
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Branch Code</em>
                                </MenuItem>
                                {branchCodes.map((branchCode) => {
                                    const branchId = branchCode.id || branchCode.branchCodeId;
                                    const branchName = branchCode.name || 'Unknown';
                                    const branchCodeValue = branchCode.code || '';
                                    
                                    return (
                                        <MenuItem key={branchId} value={branchId}>
                                            {branchName} {branchCodeValue ? `(${branchCodeValue})` : ''}
                                        </MenuItem>
                                    );
                                })}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="projectCode.id"
                                label="Project Code *"
                                value={formData.projectCode.id}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.projectCode}
                                helperText={errors.projectCode || (!selectedBranchCode ? 'Please select a branch code first' : '')}
                                disabled={loading || !selectedBranchCode}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ mr: 1, color: globalColor }}>
                                            <Code fontSize="small" />
                                        </Box>
                                    )
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Project Code</em>
                                </MenuItem>
                                {filteredProjectCodes.map((projectCode) => {
                                    const projectName = projectCode.name || 'Unknown';
                                    const projectCodeValue = projectCode.code || '';
                                    
                                    return (
                                        <MenuItem key={projectCode.id} value={projectCode.id}>
                                            {projectName} {projectCodeValue ? `(${projectCodeValue})` : ''}
                                        </MenuItem>
                                    );
                                })}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="name"
                                label="Budget Line Name *"
                                value={formData.name}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.name}
                                helperText={errors.name}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="code"
                                label="Budget Line Code *"
                                value={formData.code}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.code}
                                helperText={errors.code}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="fiscalYear"
                                label="Fiscal Year *"
                                value={formData.fiscalYear}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.fiscalYear}
                                helperText={errors.fiscalYear}
                                disabled={loading}
                            >
                                {generateFiscalYears().map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="initialBudget"
                                label="Initial Budget"
                                type="number"
                                value={formData.initialBudget}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.initialBudget}
                                helperText={errors.initialBudget}
                                disabled={loading}
                                inputProps={{
                                    min: 0,
                                    step: 0.01
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="currentBalance"
                                label="Current Balance"
                                type="number"
                                value={formData.currentBalance}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.currentBalance}
                                helperText={errors.currentBalance}
                                disabled={loading}
                                inputProps={{
                                    min: 0,
                                    step: 0.01
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="effectiveFrom"
                                label="Effective From *"
                                type="date"
                                value={formData.effectiveFrom}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.effectiveFrom}
                                helperText={errors.effectiveFrom}
                                disabled={loading}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="effectiveTo"
                                label="Effective To *"
                                type="date"
                                value={formData.effectiveTo}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.effectiveTo}
                                helperText={errors.effectiveTo}
                                disabled={loading}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <StyledTextField
                                fullWidth
                                name="description"
                                label="Description *"
                                value={formData.description}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={3}
                                error={!!errors.description}
                                helperText={errors.description}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        name="isActive"
                                        disabled={loading}
                                        sx={{
                                            color: globalColor,
                                            '&.Mui-checked': {
                                                color: globalColor
                                            }
                                        }}
                                    />
                                }
                                label="Active"
                            />
                        </Grid>

                        {editingBudgetLine && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Created By"
                                        value={editingBudgetLine.createdBy || 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Created At"
                                        value={editingBudgetLine.createdAt 
                                            ? new Date(editingBudgetLine.createdAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            }) 
                                            : 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Last Modified By"
                                        value={editingBudgetLine.lastModifiedBy || 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <StyledTextField
                                        fullWidth
                                        label="Last Modified At"
                                        value={editingBudgetLine.lastModifiedAt 
                                            ? new Date(editingBudgetLine.lastModifiedAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            }) 
                                            : 'N/A'}
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                        disabled
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                    sx={{
                                        borderColor: globalColor,
                                        color: globalColor,
                                        '&:hover': {
                                            borderColor: globalColor,
                                            backgroundColor: `${globalColor}10`
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <AnimatedButton
                                    variant="contained"
                                    startIcon={editingBudgetLine ? <SaveIcon /> : <Add />}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    size="large"
                                >
                                    {loading ? 'Saving...' : (editingBudgetLine ? 'Update Budget Line' : 'Add Budget Line')}
                                </AnimatedButton>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
        </Fade>
    );
};

export default AddEditBudgetLine;